import { gql } from '@apollo/client';

export const ParagraphInfolinoActivitiesFragment = gql`
  fragment ParagraphInfolinoActivitiesFragment on ParagraphInfolinoActivities {
    id
  }
`;
